import type { Link } from '@tbitop/routing';
import { useLink } from '@tbitop/routing';
import { ButtonActionOption } from './button-action-with-menu';

export const ButtonActionOptionLink: Link = props => {
  const Link = useLink();
  return (
    <Link role="menuitem" {...props}>
      <ButtonActionOption role="none">
        {props.children}
      </ButtonActionOption>
    </Link>
  );
};
